import { gql } from '@apollo/client'

export const CREATE_DIRECT_UPLOAD = gql`
  mutation createDirectUpload($file: FileMetadata!, $reason: DirectUploadReason) {
    createDirectUpload(file: $file, reason: $reason) {
      url
      signedId
      headers {
        key
        value
      }
    }
  }
`
